<template>
  <div>
      <iframe src="https://docs.google.com/document/d/e/2PACX-1vTjwHwHZ7CUBxpU7ovAUTrmf5TL1FiicqFjOnOAAQ-CXpuYDdWXoBIXo9SkVWvS6646cIKtzOxZcWqn/pub?embedded=true" width="100%" height="650px"></iframe>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>